import { forwardRef } from "react";
import { Typography } from "antd";
import classNames from "classnames";
import type { LinkProps } from "antd/lib/typography/Link";
import type { TextSize, TextWeight, TextType, TextLineHeight } from "../types";
import styles from "./styles.module.scss";

const { Link } = Typography;

type Props = {
  textType?: TextType;
  weight?: TextWeight;
  size?: TextSize;
  lineHeight?: TextLineHeight;
} & LinkProps;

export const AppLink = forwardRef<HTMLElement, Props>(
  ({ className, textType, weight, size, lineHeight, ...props }, ref) => {
    return (
      <Link
        ref={ref}
        className={classNames(
          [
            styles.link,
            styles[`type-${textType}`],
            styles[`size-${size}`],
            styles[`weight-${weight}`],
            styles[`line-height-${lineHeight}`],
          ],
          className,
        )}
        {...props}
      />
    );
  },
);
